// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-sort {
  display: none;
}
.row-container-outer {
  position: relative;
  background-color: rgba(0, 0, 0, 0);
  background-image: none;
  background-position: left top;
  background-repeat: no-repeat;
  padding-left: 15px;
  padding-right: 15px;
}
.row-content {
  position: relative;
  margin: auto;
  max-width: 1140px;
  width: 100%;
}
.widget {
  position: relative;
  z-index: 2;
}
.widget-content {
  height: 100%;
}
.column-Outer {
  padding: 5px 0px;
  min-height: 40px;
  position: relative;
  z-index: 1;
}
.overlay:after {
  content: "";
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: -1;
}
.main-navbar {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.navbar .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 500;
  color: #374151;
}
.navbar .nav-link.active,
.navbar .nav-link:hover {
  color: #086cd0;
}
.btn {
  padding: 0.5rem 1rem;
  font-weight: 600;
  font-size: 1rem;
  border: 1px solid var(--gray-500);
  background-color: rgba(0, 0, 0, 0);
  color: #000;
  cursor: pointer;
}
.btn-book {
  padding: 0.6rem 1.5rem;
  background-color: #1d4ed8;
  color: #fff;
  border-color: rgba(0, 0, 0, 0);
}
.banner-title {
  font-size: 2rem;
}
.apo-title {
  font-size: 1.5rem;
  font-weight: 500;
}
.service-wrapper {
  font-size: 0.9rem;
  line-height: 1.7;
}
.copyright {
  padding: 1rem 0;
  font-size: 1rem;
}
.copyright a {
  cursor: pointer;
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
}
`, "",{"version":3,"sources":["webpack://./assets/css/theme_widget.css"],"names":[],"mappings":"AAAA;EAAW,aAAA;AAEX;AAFwB;EAAqB,kBAAA;EAAkB,kCAAA;EAA+B,sBAAA;EAAsB,6BAAA;EAA6B,4BAAA;EAA4B,kBAAA;EAAkB,mBAAA;AAW/L;AAXkN;EAAa,kBAAA;EAAkB,YAAA;EAAY,iBAAA;EAAiB,WAAA;AAiB9Q;AAjByR;EAAQ,kBAAA;EAAkB,UAAA;AAqBnT;AArB6T;EAAgB,YAAA;AAwB7U;AAxByV;EAAc,gBAAA;EAAgB,gBAAA;EAAgB,kBAAA;EAAkB,UAAA;AA8BzZ;AA9Bma;EAAe,WAAA;EAAW,kBAAA;EAAkB,SAAA;EAAS,UAAA;EAAU,QAAA;EAAQ,WAAA;EAAW,WAAA;EAAW,YAAA;EAAY,oCAAA;EAAgC,WAAA;AA0C5iB;AA1CujB;EAAa,oBAAA;EAAoB,uBAAA;AA8CxlB;AA9C+mB;EAAkB,qBAAA;EAAoB,oBAAA;EAAmB,mBAAA;EAAmB,oBAAA;EAAoB,gBAAA;EAAgB,cAAA;AAsD/tB;AAtD6uB;;EAAiD,cAAA;AA0D9xB;AA1D4yB;EAAK,oBAAA;EAAmB,gBAAA;EAAgB,eAAA;EAAe,iCAAA;EAAiC,kCAAA;EAA+B,WAAA;EAAW,eAAA;AAmE96B;AAnE67B;EAAU,sBAAA;EAAqB,yBAAA;EAAyB,WAAA;EAAW,8BAAA;AAyEhgC;AAzE2hC;EAAc,eAAA;AA4EziC;AA5EwjC;EAAW,iBAAA;EAAiB,gBAAA;AAgFplC;AAhFomC;EAAiB,iBAAA;EAAgB,gBAAA;AAoFroC;AApFqpC;EAAW,eAAA;EAAe,eAAA;AAwF/qC;AAxF8rC;EAAa,eAAA;EAAe,cAAA;EAAc,kBAAA;EAAkB,oBAAA;AA8F1vC","sourcesContent":[".icon-sort{display:none}.row-container-outer{position:relative;background-color:rgba(0,0,0,0);background-image:none;background-position:left top;background-repeat:no-repeat;padding-left:15px;padding-right:15px}.row-content{position:relative;margin:auto;max-width:1140px;width:100%}.widget{position:relative;z-index:2}.widget-content{height:100%}.column-Outer{padding:5px 0px;min-height:40px;position:relative;z-index:1}.overlay:after{content:\"\";position:absolute;left:0px;right:0px;top:0px;bottom:0px;width:100%;height:100%;background-color:rgba(0,0,0,.1);z-index:-1}.main-navbar{padding-top:1.25rem;padding-bottom:1.25rem}.navbar .nav-link{padding-right:.5rem;padding-left:.5rem;font-size:1.125rem;line-height:1.75rem;font-weight:500;color:#374151}.navbar .nav-link.active,.navbar .nav-link:hover{color:#086cd0}.btn{padding:.5rem 1rem;font-weight:600;font-size:1rem;border:1px solid var(--gray-500);background-color:rgba(0,0,0,0);color:#000;cursor:pointer}.btn-book{padding:.6rem 1.5rem;background-color:#1d4ed8;color:#fff;border-color:rgba(0,0,0,0)}.banner-title{font-size:2rem}.apo-title{font-size:1.5rem;font-weight:500}.service-wrapper{font-size:.9rem;line-height:1.7}.copyright{padding:1rem 0;font-size:1rem}.copyright a{cursor:pointer;color:inherit;font-size:inherit;font-weight:inherit}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
